import { AdminAcquisitionResponse } from "../contracts/AdminAcquisitionResponse";
import { AdminAcquisition } from "../models/AdminAcquisition";

export const mapResponseToAdminAcquisition = (
  response: AdminAcquisitionResponse
): AdminAcquisition => ({
  fromDay: response.fromDay,
  toDay: response.toDay,
  totalPageViews: response.totalPageViews,
  totalMetaPageViews: response.totalMetaPageViews,
  totalEngaged: response.totalEngaged,
  totalMetaEngaged: response.totalMetaEngaged,
  totalCtaTaps: response.totalCtaTaps,
  totalMetaCtaTaps: response.totalMetaCtaTaps,
  totalArrivals: response.totalArrivals,
  totalMetaArrivals: response.totalMetaArrivals,
  totalTrialLinksRequested: response.totalTrialLinksRequested,
  totalMetaTrialLinksRequested: response.totalMetaTrialLinksRequested,
  totalTrialLinksRedeemed: response.totalTrialLinksRedeemed,
  totalMetaTrialLinksRedeemed: response.totalMetaTrialLinksRedeemed,
  totalSignUps: response.totalSignUps,
  totalSignUpsSinceArrivalCounter: response.totalSignUpsSinceArrivalCounter,
  // Newest day first — the admin reads the recent trend, not history.
  days: [...response.days].reverse().map((day) => ({ ...day })),
  pages: response.pages.map((page) => ({ ...page })),
  placements: response.placements.map((placement) => ({ ...placement })),
  // An API deployed before the by-source table sends neither field.
  sources: (response.sources ?? []).map((source) => ({ ...source })),
  totalDirectPageViews: response.totalDirectPageViews ?? 0,
});
